import styles from './editSustainabilityRow.module.scss';
import DeleteButton from '../../../../components/deleteButton/deleteButton';
import SimpleSelect from '../../../../components/simpleSelect/simpleSelect';
import { useTranslation } from 'react-i18next';
import TitleValue from '../../../../components/titleValue/titleValue';
import { Certificado } from '../../../../../../types/ObraDetails';
import { SelectOption } from '../../../../../../types/Option';

interface EditSustainabilityRowProps {
  index: number;
  cert: Certificado;
  certificateOptions: SelectOption[];
  isFieldError: (field: string) => boolean;
  getLevelCECOC: (codCertificate: string) => SelectOption[];
  handleChangeCertificate(data: SelectOption): void;
  handleChangeLevel(data: SelectOption): void;
  handleDelete?: () => void;
}

const EditSustainabilityRow = (props: EditSustainabilityRowProps) => {
  const {t} = useTranslation();
  const { index: key, cert, certificateOptions, isFieldError, getLevelCECOC, handleChangeCertificate, handleChangeLevel, handleDelete } = props;
  const originCecoc = cert.origen === 'cecoc';
  const isBreeamNewConstructionOrOtherCertificate = ['BREEAM NEW CONSTRUCTION', 'OTROS'].includes(cert.nomNivel.trim().toUpperCase());
  const currentLevelOptions = cert.niveles && cert.niveles.length > 0
    ? cert.niveles
    : [{
      id: -1, nombre: t('details.esg.sustainability.certificateNoSelected')
    }];
  const currentUpdatedLevelOptions = cert.codCertificado ? getLevelCECOC(cert.codCertificado.toString()) : [];

  const getFallbackLevelName = (
    options: SelectOption[],
    optionId?: string | number,
    optionName?: string,
    secondaryName?: string,
    fallbackName = '-',
  ) => {
    const matchingOption = options.find((option) =>
      typeof optionId !== 'undefined' && String(option.id) === String(optionId));

    return matchingOption?.nombre || optionName || secondaryName || fallbackName;
  };

  const getSelectedOption = (options: SelectOption[], optionId?: string | number, optionName?: string, fallbackName = '-') => {
    const matchingOption = options.find((option) =>
      (typeof optionId !== 'undefined' && String(option.id) === String(optionId))
      || (optionName && option.nombre === optionName));

    if (matchingOption) return matchingOption;

    return {
      id: typeof optionId !== 'undefined' ? Number(optionId) : -1,
      nombre: optionName || fallbackName,
    };
  };

  return (
    <div className={`${styles.certificates} ${key == 0 ? styles.firstElement : ''}`}>
      <div className={originCecoc ? styles.width3 : styles.width1}>
        {!originCecoc ?
          <SimpleSelect
            id={`document-type-${key}`}
            options={certificateOptions}
            value={{ id: -1, nombre: cert.nomCertificado }}
            label={t('details.esg.sustainability.type')}
            handleChangeValue={handleChangeCertificate}
            editable={!originCecoc}
          />
          :
          <TitleValue
            identifier={`document-type-${key}`}
            title={t('details.esg.sustainability.type')}
            value={cert.nomCertificado}
            onlyView={true}
          />
        }
      </div>
      <div className={originCecoc ? styles.width3 : styles.width2}>
        {
          !isBreeamNewConstructionOrOtherCertificate ?
            !originCecoc ?
              <SimpleSelect
                id={`document-type-${key}`}
                options={currentLevelOptions}
                value={getSelectedOption(currentLevelOptions, cert.codNivel, cert.nomNivel)}
                label={t(`details.esg.sustainability.${originCecoc ? 'levelInit' : 'level'}`)}
                handleChangeValue={handleChangeLevel}
                error={isFieldError('codNivel')}
                editable={!originCecoc} />
              : <TitleValue
                identifier={`document-type-${key}`}
                title={t(`details.esg.sustainability.${originCecoc ? 'levelInit' : 'level'}`)}
                value={cert.nomNivel || '-' }
                onlyView={true}
              />
            : <TitleValue
              identifier={`document-type-${key}`}
              title={t(`details.esg.sustainability.${originCecoc ? 'levelInit' : 'level'}`)}
              value='-'
              valueMaxLength={25}
              onlyView={true}
            />
        }
      </div>
      {originCecoc &&
        <div className={styles.width3}>
          {
            !isBreeamNewConstructionOrOtherCertificate ?
              <SimpleSelect
                id={`document-type-${key}`}
                options={currentUpdatedLevelOptions}
                value={getSelectedOption(
                  currentUpdatedLevelOptions,
                  cert.codNivelActualizado,
                  getFallbackLevelName(
                    currentUpdatedLevelOptions,
                    cert.codNivelActualizado,
                    cert.nomNivelActualizado,
                    cert.nomNivel,
                  ),
                )}
                label={t('details.esg.sustainability.levelUpdate')}
                handleChangeValue={handleChangeLevel}
                error={isFieldError('codNivelActualizado')}
                editable={true} />
              : <TitleValue
                identifier={`document-type-${key}`}
                title={t(`details.esg.sustainability.${originCecoc ? 'levelUpdate' : 'level'}`)}
                value='-'
                valueMaxLength={25}
                onlyView={true}
              />
          }

        </div>
      }
      {!originCecoc && handleDelete &&
        <div className={styles.trashBtn}>
          <DeleteButton id={`deleteBtn-${key}`} onClick={() => handleDelete()} />
        </div>
      }
    </div>
  );
};

export default EditSustainabilityRow;
